import {
    GET_SUBSCRIPTIONS_START,
    GET_SUBSCRIPTIONS_END,
    GET_SUBSCRIPTIONS_SUCCESS,
} from "../../actions/subscriptions";

const initialState = {
    loadings: 0,
    data: {},
};

export const subscriptionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SUBSCRIPTIONS_START: {
            return {
                ...state,
                loadings: state.loadings + 1,
            };
        }
        case GET_SUBSCRIPTIONS_END: {
            return {
                ...state,
                loadings: state.loadings > 0 ? state.loadings - 1 : 0,
            };
        }
        case GET_SUBSCRIPTIONS_SUCCESS: {
            return {
                ...state,
                data: action.subscriptions,
            };
        }
        default: {
            return state;
        }
    }
};
